import React from "react";
import { useState, useEffect } from "react";
import "./contactus.css";
import Navbar from "../../components/NavBar/Navbar";
import Footer from "../../components/Footer/Footer";
import contactq from "../../images/Contact-us/contact query.png";
import headerdesign from "../../images/header design.svg";
import assistimg from "../../images/FAQ/assist.svg";
import Select from "react-select";
import Recaptcha from "react-recaptcha";
import ScrollTop from "../../components/ScrollToTop/ScrollTop";
import CreateWhatsappChatWidget from "../../components/WhatsAppIcon";

function ContactUs() {
  const listenScrollEvent = () => {
    window.scrollY > 100
      ? (document.getElementById("return-to-top").style.display = "grid")
      : // setnavColor("#252734")
        (document.getElementById("return-to-top").style.display = "none");
  };
  useEffect(() => {
    window.addEventListener("scroll", listenScrollEvent);
    return () => {
      window.removeEventListener("scroll", listenScrollEvent);
    };
  }, []);

  var url =
    "https://wati-integration-service.clare.ai/ShopifyWidget/shopifyWidget.js?3023";
  var s = document.createElement("script");
  s.type = "text/javascript";
  s.async = true;
  s.src = url;
  var wpoptions = {
    enabled: true,
    chatButtonSetting: {
      backgroundColor: "#4dc247",
      ctaText: "",
      borderRadius: "25",
      marginLeft: "0",
      marginBottom: "50",
      marginRight: "50",
      position: "right",
    },
    brandSetting: {
      brandName: "SKYLARK",
      brandSubTitle: "Typically replies within a day",
      brandImg:
        "https://skylark-website-images.s3.ap-south-1.amazonaws.com/logo_res.png",
      welcomeText: "Hi there!\nHow can I help you?",
      messageText:
        "Hello team SKYLARK, I have an upcoming event.\nWhen can we schedule a meeting to discuss the details and requirements?",
      backgroundColor: "#8e0405",
      ctaText: "Start Chat",
      borderRadius: "25",
      autoShow: false,
      phoneNumber: "916201811075",
    },
  };
  s.onload = function () {
    CreateWhatsappChatWidget(wpoptions);
  };
  var x = document.getElementsByTagName("script")[0];
  x.parentNode.insertBefore(s, x);

  const [inputs, setInputs] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: null,
    WhatsAppNumber: "",
    comments: "",
    eventCategory: "",
  });

  const options = [
    { value: "Wedding", label: "Wedding" },
    { value: "Destination Wedding", label: "Destination Wedding" },
    { value: "Haldi, Mehndi and Sangeet", label: "Haldi, Mehndi and Sangeet" },
    { value: "Corporate Events", label: "Corporate Events" },
    { value: "Birthday Parties", label: "Birthday Parties" },
    { value: "Surprise Parties", label: "Surprise Parties" },
    {
      value: "Coctail Party/ Bachelor Party",
      label: "Coctail Party/ Bachelor Party",
    },
    { value: "Concerts", label: "Concerts" },
    { value: "First Night Decor", label: "First Night Decor" },
  ];

  const [selectedOption, setSelectedOption] = useState(null);

  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  const [formConfirm, setFormConfirm] = useState();

  const recaptchaOnload = (value) => {
    console.log("ReCaptcha loaded");
  };

  const [verified, setVerified] = useState(false);

  const recaptchaVerifyCallback = (response) => {
    if (response) {
      console.log("ReCaptcha verified");
      setVerified(true);
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    // console.log(
    //   JSON.stringify({ ...inputs, eventCategory: selectedOption.value })
    // );

    fetch("/contacts", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ ...inputs, eventCategory: selectedOption.value }),
    })
      .then((res) => res.json())
      .then((res) => setFormConfirm(res));
  };

  return (
    <div className="page_container contact_container">
      <div className="contact_page_header">
        <Navbar />

        <div className="pages_header_content">
          <p className="contact_header_text">Contact Us</p>

          <img className="header_design" src={headerdesign} />
        </div>
      </div>
      <ScrollTop />

      <div className="contact_form_image">
        <div className="contact_form_container">
          <div className="contact_form_heading">
            <img src={assistimg} />
            <p>
              Get In <span style={{ color: "#8E0405" }}>touch</span>{" "}
              <span style={{ borderBottom: "3px solid #8E0405" }}>with us</span>{" "}
            </p>
          </div>

          {!formConfirm ? (
            <form onSubmit={handleSubmit}>
              <div className="contact_form_names">
                <div className="contact_form_label_input">
                  <label className="contact_form_label" for="firstname">
                    First Name
                  </label>
                  <input
                    type="text"
                    id="firstname"
                    required
                    placeholder="Enter Your First Name"
                    className="contact_form_input"
                    onChange={handleChange}
                    name="firstName"
                    value={inputs.firstName || ""}
                  />
                </div>

                <div className="contact_form_label_input">
                  <label className="contact_form_label" for="lastname">
                    Last Name
                  </label>
                  <input
                    type="text"
                    id="lastname"
                    required
                    placeholder="Enter Your Last Name"
                    className="contact_form_input"
                    onChange={handleChange}
                    name="lastName"
                    value={inputs.lastName || ""}
                  />
                </div>
              </div>

              <div className="contact_form_details">
                <div className="contact_form_label_input">
                  <label className="contact_form_label" for="email">
                    Email
                  </label>
                  <input
                    type="email"
                    id="email"
                    required
                    placeholder="Enter Your Email"
                    className="contact_form_input"
                    onChange={handleChange}
                    name="email"
                    value={inputs.email || ""}
                  />
                </div>

                <div className="contact_form_label_input">
                  <label className="contact_form_label" for="phoneno">
                    Phone Number
                  </label>
                  <input
                    type="tel"
                    id="phoneno"
                    required
                    minLength="10"
                    placeholder="Enter Your Phone Number"
                    className="contact_form_input"
                    onChange={handleChange}
                    name="phoneNumber"
                    value={inputs.phoneNumber || ""}
                  />
                </div>
              </div>

              <div className="contact_form_label_input">
                <label className="contact_form_label" htmlFor="WhatsAppNumber">
                  WhatsApp Number
                </label>
                <input
                  type="tel"
                  id="WhatsAppNumber"
                  required
                  placeholder="Enter Your WhatsApp Number"
                  className="contact_form_input"
                  onChange={handleChange}
                  name="WhatsAppNumber"
                  value={inputs.WhatsAppNumber || ""}
                />
              </div>

              <div
                style={{ marginTop: "20px", marginBottom: "20px" }}
                className="contact_form_label_input"
              >
                <label className="contact_form_label" for="comment">
                  Comments
                </label>
                <input
                  type="text"
                  id="comment"
                  placeholder="Any Comments"
                  className="contact_form_input"
                  onChange={handleChange}
                  name="comments"
                  value={inputs.comments || ""}
                />
              </div>

              <div className="contact_form_label_input">
                <label className="contact_form_label" for="eventcat">
                  Event Category
                </label>

                <Select
                  id="eventcat"
                  required
                  className="contact_form_dropdown"
                  name="eventCategory"
                  value={selectedOption}
                  defaultValue={selectedOption}
                  onChange={setSelectedOption}
                  options={options}
                />

                <Recaptcha
                  sitekey="6LfcsDshAAAAAPiHFqN6mc0_PbD0Eatcw04AP-k_"
                  render="explicit"
                  verifyCallback={recaptchaVerifyCallback}
                  onloadCallback={recaptchaOnload}
                />

                <button
                  style={
                    !verified
                      ? {
                          backgroundColor: "rgba(142, 4, 5, 0.3)",
                          color: "#fff",
                          cursor: "default",
                        }
                      : null
                  }
                  type="submit"
                  className="contact_submit_btn"
                >
                  Send
                </button>
              </div>
            </form>
          ) : (
            <div className="contact_form_confirm">
              <svg
                style={{
                  width: "40px",
                  height: "40px",
                  margin: "auto",
                }}
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="green"
              >
                <path
                  fill-rule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                  clip-rule="evenodd"
                ></path>
              </svg>{" "}
              <p>Thank you for contacting us</p>
              <p>We'll get back to you soon</p>
            </div>
          )}
        </div>

        <div className="contact_right_cont">
          <p className="contact_query_heading">
            Resolve Queries/Doubts Quickly.
          </p>

          <p className="contact_query_text">
            With our supporting team, get assistance quickly for hastle free
            experience.{" "}
          </p>

          <img className="contact_image" src={contactq} />
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default ContactUs;
